<template>
  <div class="bg-blue-lightest">
    <div class="pageContent wider">
      <ProgressBar :value="100"  />
      <div class="shadow bg-white">
        <div class="system-header">
          <div class="system-header-image">
            <img src="/img/magic-clipboard@2x.png" alt="Clipboard" />
          </div>
          <div>
            <div class="pageTitle">
              Schedule your install
            </div>
            <div>
              <div class="text-bold">Professional security for</div>
              <div>{{ address }}</div>
            </div>
          </div>
        </div>
  
        <SystemAndMonitoringSummary :system="system" />

        <div class="buttons">
          <div class="mb-8">
            <div class="text-bold mb-2">Installation dates as soon as tomorrow</div>
            <router-link to="/checkout" class="button">Schedule Install</router-link>
          </div>
          
          <div>
            <div class="text-bold">Want to talk to a pro?</div>
            <div class="mb-2">
              Get your questions answered and review your system with a pro.
            </div>
            <router-link to="/system-review" class="button outline">Review My System</router-link>
          </div>
        </div>

      </div>

      <EquipmentSummary :equipment.sync="equipment" @change="handleEquipmentChange" />

      <!-- <div class="window-protection-card">
        <div>
          <img src="/img/icon-open-window.png" alt="Open Window" />
        </div>
        <div class="content">
          <div class="text-bold">Consider adding window protection</div>
          <div>Ranch style homes like yours typically have easily accessible windows. We recommend considering some forms of window protection.</div>
        </div>
        <div class="link-section">
          <router-link to="/window-protection">Add window protection</router-link>
        </div>
      </div>-->
    </div>

    <ModuleCardGrid />

    <div class="continue-section">
      <continue-button text="Finish" to="/checkout" />
      <ModuleNeedHelp />
    </div>
  </div>
</template>

<script>
import EquipmentSummary from "../components/EquipmentSummary.vue";
import ProgressBar from "../components/ProgressBar.vue";
import ModuleNeedHelp from "../components/ModuleNeedHelp.vue";
import SystemAndMonitoringSummary from "../components/SystemAndMonitoringSummary.vue";
import ModuleCardGrid from "../components/ModuleCardGrid.vue";

export default {
  components: {
    EquipmentSummary,
    ProgressBar,
    ModuleNeedHelp,
    SystemAndMonitoringSummary,
    ModuleCardGrid,
  },
  data: () => ({
    system: {
      equipment: {
        cameras: [],
        essential: [],
        homeAutomation: [],
        environmental: []
      }
    },
    address: ``
  }),
  computed: {
    equipment() {
      return this.system.equipment;
    }
  },
  methods: {
    async updateSystem() {
      let { data } = await this.$axios.get("/ajax/system");
      this.system = data;
      this.address = this.$store.state.lead.addressFormatted;
    },

    async handleEquipmentChange({ id, price, quantity }) {
      await this.$store.dispatch('setCartItem', {
        id,
        price,
        quantity
      })

      await this.$store.dispatch('save')

      await this.updateSystem()
    }
  },
  async mounted() {
    this.updateSystem();
  }
};
</script>

<style lang="scss" scoped>
.pageContent {
  padding: 3rem 1rem;
  min-height: 90vh;
  max-width: 850px;
}
.system-header {
  display: flex;
  align-items: center;
  padding: 2rem 2rem 0;
  /* margin-bottom: 4rem; */
  @media (max-width: 480px) {
    margin-bottom: 2rem;
  }
  img {
    display: block;
    max-width: 115px;
    margin-right: 2.5rem;
  }
  .system-header-image {
    @media (max-width: 480px) {
      display: none;
    }
  }
}

.buttons {
  padding: 0 2rem 2rem;
}

.window-protection-card {
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  display: flex;
  margin: 2.625rem 2rem;
  padding: 2rem;
  font-size: 0.813rem;
  align-items: center;
  line-height: 1.5;

  @media (max-width: 480px) {
    flex-direction: column;
    padding: 1rem;
    text-align: center;
  }

  .content {
    padding: 0 2rem;
    @media (max-width: 480px) {
      padding: 0;
    }
  }
  .link-section {
    flex-shrink: 0;
    @media (max-width: 480px) {
      margin-top: 1rem;
    }
  }
}

.additional-section {
  padding: 4rem 1rem;

  .section-icon {
    max-width: 50px;
  }

  .text-bold {
    font-size: 1.2em;
    margin-bottom: 0.25em;
  }

  .content {
    max-width: 334px;
    margin: 0 auto;
  }
}

.additional-tiles {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
}

.additional-tile {
  margin: 0 0.5rem;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  overflow: hidden;
  max-width: 343px;
  @media (max-width: 768px) {
    margin: 0 0 1rem;
  }
  img {
    display: block;
    width: 100%;
  }
}
</style>

<style src="../../sass/components/continue-section.css" scoped></style>
